import dynamic from 'next/dynamic'
import { CallBackWizardProps } from './CallBackWizard'

export const DynamicCallBackWizard = dynamic<CallBackWizardProps>(
  () => import('./CallBackWizard').then((md) => md.CallBackWizard),
  { ssr: false }
)
